import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Redirect, RouteComponentProps, useParams } from 'react-router-dom';

export enum CoursePageTestId {
    Container = 'CoursePageTestIdContainer',
}
interface RouteParams {
    slug: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props extends RouteComponentProps<RouteParams> {}

export const CoursePage: React.FC<Props> = () => {
    const { slug } = useParams<RouteParams>();
    const { showCoursesOnWeb } = useFlags();

    if (!showCoursesOnWeb) {
        return <Redirect to="/dashboard" />;
    }

    return <div data-testid={CoursePageTestId.Container}>Rendering Course for Slug: {slug}</div>;
};
